import { Link as RouterLink, Outlet } from "react-router-dom";
import { AppBar, Box, Link, Toolbar, Typography } from "@mui/material";
import MenuBookOutlined from "@mui/icons-material/MenuBookOutlined";

/**
 * Reading chrome for the Learn library.
 *
 * Deliberately not the marketing layout. Partly presentation: that one
 * floats a pill-shaped navbar over the page once you scroll, which is
 * fine for a landing page of discrete sections and bad for continuous
 * prose, where it sits on top of whatever you are reading.
 *
 * Mostly, though, this is reference material for people already using
 * the app, reached from the account menu — not a marketing surface. It
 * stays reachable without an account so demo visitors and shared links
 * work, but nothing on the landing page advertises it, and the only way
 * out of it is back into the app. A slim bar also travels better into an
 * LMS frame, where marketing chrome is noise.
 */
export default function LearnLayout() {
  return (
    <Box sx={{ minHeight: "100vh", bgcolor: "background.default" }}>
      <AppBar position="sticky" elevation={0} color="default">
        <Toolbar variant="dense" sx={{ gap: 1.5 }}>
          <MenuBookOutlined fontSize="small" />
          <Typography variant="subtitle2" sx={{ flexGrow: 1 }}>
            <Link
              component={RouterLink}
              to="/learn"
              color="inherit"
              underline="none"
            >
              Learn
            </Link>
          </Typography>
          <Link
            component={RouterLink}
            to="/annogram"
            color="inherit"
            underline="hover"
            variant="body2"
          >
            Back to the app
          </Link>
        </Toolbar>
      </AppBar>
      <Outlet />
    </Box>
  );
}
